import { render, staticRenderFns } from "./createList.vue?vue&type=template&id=5a6b0850&scoped=true"
import script from "./createList.vue?vue&type=script&lang=js"
export * from "./createList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6b0850",
  null
  
)

export default component.exports